import { useContext, useState } from "react";
import { Dialog } from '../dialogs/dialog';
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { ExplainedButton as Button } from '../explained-button';
import { ThemeDto } from "../../general/dtos";
import { ThemesDataContext, ThemesDataContextValue } from "../../providers/theme-management-provider";

interface CreateThemeDialogProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (name: string, baseTheme: string) => void;
}

export function CreateThemeDialog({ visible, onCancel, onCreate }: CreateThemeDialogProps) {
    const ctx = useContext<ThemesDataContextValue | null>(ThemesDataContext);
    const { themes } = ctx!;
    const [name, setName] = useState("");
    const [baseTheme, setBaseTheme] = useState<string | null>(null);

    const handleCreate = () => {
        if (name && baseTheme) {
            onCreate(name, baseTheme);
            setName("");
            setBaseTheme(null);
        }
    };

    return (
        <Dialog 
            header="Create new theme" 
            visible={visible} 
            onHide={onCancel} 
            style={{ width: '400px' }}
            modal
        >
            <div className="flex flex-column gap-3 mt-2">
                <div className="flex flex-column gap-1">
                    <label htmlFor="themeName">Theme name</label>
                    <InputText 
                        id="themeName"
                        placeholder="e.g., Corporate Dark" 
                        value={name} 
                        onChange={(e) => setName(e.target.value)} 
                    />
                </div>

                <div className="flex flex-column gap-1">
                    <label htmlFor="baseTheme">Derived from</label>
                    <Dropdown 
                        id="baseTheme"
                        options={themes.standard} 
                        optionLabel="label" 
                        optionValue="value"
                        placeholder="Select a base theme..." 
                        value={baseTheme} 
                        onChange={(e) => {
                            setBaseTheme(e.value);
                        }}
                        className="w-full"
                        scrollHeight={'500px'}
                    />
                </div>

                <div className="admin-toolbar flex justify-content-end gap-2 mt-3">
                    <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={onCancel} />
                    <Button 
                        label="Create" 
                        icon="pi pi-check" 
                        onClick={handleCreate} 
                        disabled={!name || !baseTheme} 
                        disabledReason={!name ? 'Enter a name for the new theme.' : 'Select a base theme first.'}
                    />
                </div>
            </div>
        </Dialog>
    );
}
